"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactUse = require("react-use");

var _utils = require("@alycecom/utils");

/**
 * Hook for adding library script by scripts name with callbacks.
 * @param {string} scriptPath - Path to the script. Can be internal or external.
 * @param {CallbackWithOptional} onLoad - Callback on successfully load of script.
 * @param {CallbackWithOptional} onError - Callback on error during script loading.
 *
 * @example
 *
 * Somewhere in component code
 *
 * ...
 * const { injectJavascript } = useJavascript('/segment.js', onSegmentLoad);
 * const handleClickSomeButton = useCallback(
 *   () => {
 *     injectJavascript();
 *   },
 *   [injectJavascript],
 * );
 * ...
 */
var _default = function _default(scriptPath) {
  var onLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var initialSet = window.injectedScripts || new Set([]);

  var _useSet = (0, _reactUse.useSet)(initialSet),
      _useSet2 = (0, _slicedToArray2["default"])(_useSet, 2),
      set = _useSet2[0],
      _useSet2$ = _useSet2[1],
      add = _useSet2$.add,
      has = _useSet2$.has;

  var injectJavascript = (0, _react.useCallback)(function () {
    if (!has(scriptPath)) {
      var script = document.createElement('script');
      script.src = scriptPath;
      script.async = true;
      document.body.appendChild(script);

      script.onload = function () {
        add(scriptPath);

        if (onLoad && (0, _utils.isFunction)(onLoad)) {
          onLoad();
        }
      };

      script.onerror = function () {
        if (onError && (0, _utils.isFunction)(onError)) {
          onError();
        }
      };
    }

    window.injectedScripts = set;
  }, [has, add, set, scriptPath, onLoad, onError]);
  return {
    injectedScripts: set,
    injectJavascript: injectJavascript
  };
};

exports["default"] = _default;